// extracted by mini-css-extract-plugin
export default {"wrapper":"ThreeDots_wrapper__h0WUd","dot":"ThreeDots_dot__siCvw","pulse":"ThreeDots_pulse__to1nc"};